import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2025 BKB Électroménager. Tous droits réservés.</p>
      </div>
    </footer> 
  );
};

export default Footer;